import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  importProvidersFrom,
} from '@angular/core';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { ACCOUNT_SERVICE_TOKEN, AuthNgModule } from '@seech/auth-ng';
import { LayoutNgModule } from '@seech-sub/layout-ng';
import { UxNgModule } from '@seech/ux-ng';
import { appRoutes } from './app.routes';
import { environment } from '../environments/environment';
import { AccountClientService } from './clients';
import { withApplicationBundleRecovery } from '@seech-sub/core-ng';
import { OperationsAccessInterceptor } from './security/interceptors/operations-access.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(appRoutes, withApplicationBundleRecovery()),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(
      UxNgModule,
      LayoutNgModule.forRoot({
        hasSearch: false,
        sharedCdnUrl: environment.SHARED_CDN_URL,
        globalCdnUrl: environment.GLOBAL_CDN_URL,
      }),
      AuthNgModule.forRoot({
        AUTH_API_URL: environment.AUTH_API_URL,
        AUTH_WEB_URL: environment.AUTH_WEB_URL,
        BASE_API_URL: environment.BASE_API_URL,
        CLIENT_ID: environment.CLIENT_ID,
        SESSION_TIMEOUT: { INTERVAL: 300000, COUNTDOWN: 60000 },
      })
    ),
    { provide: ACCOUNT_SERVICE_TOKEN, useClass: AccountClientService },
    /**
     * Registered after the library modules on purpose. Interceptors see a
     * response travelling back out in reverse registration order, so the one
     * declared last is the first to see an error - which is what lets this
     * swallow the API refusal before anything upstream can render it.
     */
    {
      provide: HTTP_INTERCEPTORS,
      useClass: OperationsAccessInterceptor,
      multi: true,
    },
  ],
};
